import { useState } from "react";
import { put } from "../common/api/apiShared";
import { useStateUrlParams } from "../common/hooks/useStateUrlParams";
import { useTranslation } from "../localization/useTranslation";
import { useNavMenuDataMapping } from "../main/NavMenu/NavMenu.hooks";
import { NotificationViewModel } from "./Notification.types";
import { DotLegalBreadCrumbModel } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalQuery, useDotLegalMutation, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useNotificationDataMapping() {
    const { translateString } = useTranslation();

    const [showDeleteNotificationDialog, setShowDeleteNotificationDialog] = useState(false);
    const [selectedNotificationId, setSelectedNotificationId] = useStateUrlParams("notificationId", "");
    const { isLoading, data, refetch } = useDotLegalQueryWithKey<Array<NotificationViewModel>>("notifications", "/notification/details");
    let videoQuery = useDotLegalQueryWithKey<string>("introVideoLink", "/videolink/intro");

    const { refetchMenuNotifications } = useNavMenuDataMapping();

    const editMutation = useDotLegalMutation(update);

    function update(id: string) {
        return put<string>(`/notification/${id}/markasread`, true);
    }

    const updateNotificationState = (notificationId: string) => {
        editMutation.mutateAsync(notificationId!, {
            onSuccess: (r: any) => {
                refetchNotifications();
            },
        });
    };

    let selectedNotification;
    if (data && selectedNotificationId) {
        selectedNotification = data?.find((x) => x.id === selectedNotificationId);

        if (selectedNotification && selectedNotification!.isRead === false) {
            selectedNotification!.isRead = true;
            updateNotificationState(selectedNotification!.id);
        }
    }

    const getBreadCrumbs = () => {
        let breadCrumbs: Array<DotLegalBreadCrumbModel> = [];

        breadCrumbs.push({ name: translateString("notifications") });
        return breadCrumbs;
    };
    const refetchNotifications = () => {
        refetch();
        refetchMenuNotifications();
    };

    return {
        isLoading,
        getBreadCrumbs,
        data,
        selectedNotificationId,
        setSelectedNotificationId,
        selectedNotification,
        videoData: videoQuery.data,
        hasNotifications: isLoading || data!.length > 0,
        updateNotificationState,
        showDeleteNotificationDialog,
        setShowDeleteNotificationDialog,
        refetchNotifications,
    };
}
